export const profileStyles = {
  container: {
    marginTop: "2rem",
    width: {
      xs: "90vw", // small
      sm: "60vw", // tab
      md: "30vw", // large
    },
  },

  avatarContainer: {
    marginTop: "1rem",
    textAlign: "center",
  },

  avatar: {
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    objectFit: "cover",
    margin: "0 auto",
  },

  nameText: {
    fontSize: "32px",
    fontWeight: "700",
  },

  profileButton: {
    marginTop: "2rem",
    width: "100%",
    gap: "8px",
  },

  aboutContainer: {
    marginTop: "4px",
  },

  aboutTitle: {
    fontSize: "22px",
    fontWeight: "600",
    marginTop: "25px",
  },

  metricsContainer: {
    fontSize: "22px",
    fontWeight: "600",
    marginTop: "25px",
  },

  metricsText: {
    fontStyle: "italic",
    fontFamily: "400",
    fontSize: "17px",
    fontWeight: "400",
  },

  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50vh",
  },

  errorContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  errorText: {
    fontSize: "17px",
    fontWeight: "500",
  },

  metricsTitle: {
    fontSize: "22px",
    fontWeight: "600",
  },

  profileInfoItem: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    mt: 1,
    gap: "8px",
  },

  profileInfoIcon: {
    width: 16,
    height: 18,
  },

  profileInfoText: {
    fontFamily: "400",
    fontSize: "17px",
    fontWeight: "400",
  },

  metricItemContainer: {
    marginTop: "15px",
  },

  metricItemInnerContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  metricItemContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
  },

  metricItemLabel: {
    fontFamily: "400",
    fontSize: "17px",
    fontWeight: 400,
  },

  metricItemValue: {
    fontFamily: "400",
    fontSize: "17px",
    fontWeight: 400,
  },
  italicText: {
    fontStyle: "italic",
    fontFamily: "400",
    fontSize: "17px",
    fontWeight: "400",
  },

  // stats styles
  statsContainer: {
    marginTop: "10px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  statBox: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#d0eed533",
    border: "1px solid #000",
    borderRadius: "12px",
    paddingX: "15px",
    paddingY: "10px",
    gap: "15px",
  },
  statsHeading: {
    color: "#000",
    fontWeight: "600",
    fontSize: "22px",
  },
  statsNumber: {
    color: "#000",
    fontWeight: "600",
    fontSize: "32px",
    lineHeight: "40px",
  },
  statsCategory: {
    color: "#000",
    fontWeight: "400",
    fontSize: "15px",
  },
  statsBoxFooter: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
};
